import { Coupon } from './../coupon.model';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-coupon-form',
  templateUrl: './coupon-form.component.html',
  styleUrls: ['./coupon-form.component.css']
})
export class CouponFormComponent implements OnInit {

  @Input()
  coupon: Coupon;

  constructor() { }

  ngOnInit() {
  }

}
